import { createSlice } from "@reduxjs/toolkit";
import { AUTH_LOCALSTORAGE_NAME } from "../../constants/constants";
import { AuthInitialState } from "../../types/auth";

const initialState: AuthInitialState = {
  access_token: undefined,
  user: undefined,
  role: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state, action) => {
      state.access_token = action.payload?.access_token;
      state.user = action.payload?.user;
      state.role = action.payload?.role;

      localStorage.setItem(
        AUTH_LOCALSTORAGE_NAME,
        JSON.stringify(action.payload)
      );
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.user = undefined;
      state.role = undefined;
      localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    },
    setSuccessSignup: (state, action) => {
      state.isSuccessSignup = action.payload;
    },
  },
});

export const { userLoggedIn, userLoggedOut, setSuccessSignup } =
  authSlice.actions;
export default authSlice.reducer;
